var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{on:{"submit":() => null}},[_c('FormField',_vm._b({attrs:{"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'FormField',_vm.config,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }